import type React from "react"

import { useState } from "react"

interface ToggleProps {
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (checked: boolean) => void
  label?: string
}

const Toggle: React.FC<ToggleProps> = ({ isChecked = false, isDisabled = false, onChange, label }) => {
  const [checked, setChecked] = useState(isChecked)

  const handleToggle = () => {
    if (isDisabled) return

    const newValue = !checked
    setChecked(newValue)
    onChange?.(newValue)
  }

  return (
    <div className={`toggle-container ${isDisabled ? "toggle-disabled" : ""}`}>
      {label && <span className="toggle-label">{label}</span>}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`toggle ${checked ? "toggle-active" : ""} ${isDisabled ? "toggle-disabled" : ""}`}
        onClick={handleToggle}
        disabled={isDisabled}
      >
        <span className="toggle-thumb"></span>
      </button>
    </div>
  )
}

export default Toggle
